import { render, staticRenderFns } from "./DropdownView.vue?vue&type=template&id=35e5684a"
import script from "./DropdownView.vue?vue&type=script&lang=js"
export * from "./DropdownView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports